import React from 'react';
import styled from 'styled-components/macro';
import { Box, Tab, Tabs } from '@material-ui/core';
import { ContractInfoSection } from './ContractInfoSection';
import { translations } from '../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import { BillingItemsTab } from './BillingItemsTab';
import { CorrespondingInvoiceTab } from './CorrespondingInvoiceTab';
import AmendmentDrawer from './AmendmentDrawer';
import { HistoryTab } from './HistoryTab';
import { useSelector } from 'react-redux';
import { selectAccessRight } from '../../WorkListPage/slice/selectors';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

export function BiBaseTab(props) {
  const { t } = useTranslation();
  const { reloadAmendment, setSelectedTab } = props;
  const [value, setValue] = React.useState(0);
  const [renewedLink, setRenewedLink] = React.useState<string>('/');
  const accessright = useSelector(selectAccessRight);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    setSelectedTab(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  function handleOnClickRenewed() {
    props.history.push(renewedLink);
  }

  return (
    <Wrapper>
      <Box className='tab-container'>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleTabChange}
                textColor='primary'
                indicatorColor='primary'>
            <Tab
              label={t(translations.contractDetail.billingInstruction)}
              {...a11yProps(0)}
            />
            <Tab
              label={t(translations.contractDetail.correInvoice)}
              {...a11yProps(1)}
            />
            {accessright.edit &&
            <Tab
              label={t(translations.contractDetail.history)}
              {...a11yProps(2)}
            />
            }
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div className='bi-container'>
            <div className='left-bi'>
              <ContractInfoSection handleOnClickRenewed={handleOnClickRenewed} setRenewedLink={setRenewedLink} />
              <BillingItemsTab />
            </div>
            <div className='right-bi'>
              <AmendmentDrawer reloadList={reloadAmendment} />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CorrespondingInvoiceTab />
        </TabPanel>
        {accessright.edit &&
        <TabPanel value={value} index={2}>
          <HistoryTab />
        </TabPanel>
        }
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 10px;
  width: 100%;
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .tab-container {
    .bi-container {
      display: flex;

      .left-bi {
        width: 70%;
      }

      .right-bi {
        width: 30%;
      }
    }

    .MuiBox-root {
      padding: 5px;
    }
  }

  .MuiTab-root {
    text-transform: inherit;
  }

  .screencap {
    width: 100%;
  }
`;
